import { ICommand } from 'core-ts-types';
import { ResourceCategoriesQuery } from './../../queries/resource_categories_query';

export class ResourceCategoriesController {
  constructor(
    private selectResourceCategoryCommand: ICommand,
    private ngResourceCategoriesQuery: ResourceCategoriesQuery
  ) {
    if (!_.isEmpty(this.ngResourceCategoriesQuery.result.categories)) {
      this.selectResourceCategoryCommand(_.first(this.ngResourceCategoriesQuery.result.categories));
    }
  }
}

angular.module('capability-ng-resources').controller('ngResourceCategoriesController', ResourceCategoriesController);



// WEBPACK FOOTER //
// ./app/lib/resources/views/resource_categories/resource_categories.ts